<template>
  <div style="height: 100%; width: 100%;">
    <el-menu
      :default-active="this.$router.currentRoute.path == '/admin/inventory' ? ($store.getters.hasPermission(['All', 'Inventory']) ? '/admin/inventory/requests' : '/admin/inventory/approvals') : this.$router.currentRoute.path"
      :router="true"
      mode="horizontal"
    >
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Inventory'])"
        index="/admin/inventory/requests"
      >Requests</el-menu-item>
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Inventory'])"
        index="/admin/inventory/users"
      >Users</el-menu-item>
      <el-menu-item index="/admin/inventory/approvals">Approvals</el-menu-item>
      <el-menu-item
        v-if="$store.getters.hasPermission(['All', 'Inventory'])"
        index="/admin/inventory/items"
      >Items</el-menu-item>
    </el-menu>
    <div style="margin: 16px;">
      <el-card shadow="hover">
        <router-view></router-view>
      </el-card>
    </div>
  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    mounted() {
        this.$store.dispatch("pullInventory");
    },
    computed: {...mapFields(["user", "inventory", "inventoryTypes", "canApprove"])},
    created() {
        if(this.$router.currentRoute.path == '/admin/inventory'){
            this.$router.push(this.$store.getters.hasPermission(['All', 'Inventory']) ? '/admin/inventory/requests' : '/admin/inventory/approvals');
        }
    },
    data() {
        return {};
    }
};
</script>
